import { store } from "../../state/store.js";
import { tpKey } from "../../core/tpKey.js";
import {
  matchBy4Fields,
  ownFavKeys,
  keysFromFavList,
  toggleGroup,
} from "../../core/favorites.js";
import {
  FREE_TO_AIR_DE,
  SKY_DE,
  HDPLUS,
  TELEVES_K20_16,
} from "../../constants/favorites.js";
import { renderDetailsRow } from "./detailsRow.js";
import { updateUI } from "../updateUI.js";
import { getIntermediateFrequencyMHz, getPolBandLabel } from "../../utils/sat.js";
import { getBitrateRowTitle, isHighBitrateTp } from "../../utils/bitrate.js";
import { appendButton, appendCell, appendStatusPill } from "../../utils/render.js";

function bindSelectAll(btnId, keys) {
  const btn = document.getElementById(btnId);
  if (!btn) return;
  btn.disabled = keys.length === 0;
  btn.onclick = (e) => {
    e.preventDefault();
    toggleGroup(keys);
    updateUI();
  };
}

function renderFavList(tbodyId, list4) {
  const tbody = document.getElementById(tbodyId);
  if (!tbody) return;

  tbody.innerHTML = "";

  for (const fav of list4) {
    const hit = store.transponders.find((t) => matchBy4Fields(t, fav));
    const key = hit ? (hit.tp_key || tpKey(hit)) : "";
    const selected = !!key && store.selection.has(key);
    const isOpen = !!key && store.openDetails.has(key);
    const star = !!key && store.starred.has(key);
    const progCount = !!key ? (store.programsByTpKey.get(key) || []).length : 0;

    const tr = document.createElement("tr");
    if (hit && isHighBitrateTp(hit)) {
      tr.classList.add("high-bitrate");
      tr.title = getBitrateRowTitle(hit);
    }

    appendCell(
      tr,
      hit
        ? (hit.tp_name || hit.provider || key)
        : `${fav.sat_pos} ${fav.frequency_MHz} ${getPolBandLabel(fav.pol, fav.frequency_MHz)} ${fav.symbolrate_kSps}`
    );

    const detailsCell = appendCell(tr, "", { className: "nowrap" });
    appendButton(detailsCell, {
      label: `${isOpen ? "▾" : "▸"} Details`,
      disabled: !key,
      dataset: { act: "toggle_details", key },
    });

    appendCell(tr, fav.sat_pos, { className: "nowrap" });
    appendCell(tr, fav.frequency_MHz, { className: "nowrap" });
    appendCell(tr, getIntermediateFrequencyMHz(fav.frequency_MHz) || "", { className: "nowrap" });
    appendCell(tr, getPolBandLabel(fav.pol, fav.frequency_MHz) || "", { className: "nowrap" });
    appendCell(tr, fav.symbolrate_kSps, { className: "nowrap" });
    appendCell(tr, hit?.dvb || "", { className: "nowrap" });
    appendCell(tr, hit?.tsid_onid || (hit?.tsid ? `${hit.tsid}/${hit.onid || ""}` : ""), { className: "nowrap" });

    const statusCell = appendCell(tr, "", { className: "nowrap" });
    if (hit) {
      statusCell.textContent = String(progCount);
    } else {
      appendStatusPill(statusCell, "fehlt", "background:#F39200;color:white;border-color:#F39200");
    }

    const actionsCell = appendCell(tr, "", { className: "nowrap" });
    const actions = document.createElement("div");
    actions.className = "actions";
    actionsCell.appendChild(actions);

    appendButton(actions, {
      label: selected ? "✓" : "＋",
      className: selected ? "primary" : "",
      disabled: !key,
      dataset: { act: "toggle_sel", key },
    });
    appendButton(actions, {
      label: star ? "★" : "☆",
      title: "Favorit",
      disabled: !key,
      dataset: { act: "toggle_star", key },
    });

    tbody.appendChild(tr);

    if (isOpen) {
      tbody.appendChild(renderDetailsRow(key, 11));
    }
  }
}

function renderOwnFav() {
  const tbody = document.getElementById("ownFavTbody");
  if (!tbody) return;

  tbody.innerHTML = "";

  for (const key of ownFavKeys()) {
    const tp = store.tpByKey.get(key);
    if (!tp) continue;

    const selected = store.selection.has(key);
    const isOpen = store.openDetails.has(key);
    const progCount = (store.programsByTpKey.get(key) || []).length;

    const tr = document.createElement("tr");
    if (isHighBitrateTp(tp)) {
      tr.classList.add("high-bitrate");
      tr.title = getBitrateRowTitle(tp);
    }

    appendCell(tr, tp.tp_name || tp.provider || key);

    const detailsCell = appendCell(tr, "", { className: "nowrap" });
    appendButton(detailsCell, {
      label: `${isOpen ? "▾" : "▸"} Details`,
      dataset: { act: "toggle_details", key },
    });

    appendCell(tr, tp.sat_pos || "", { className: "nowrap" });
    appendCell(tr, tp.frequency_MHz || "", { className: "nowrap" });
    appendCell(tr, getIntermediateFrequencyMHz(tp.frequency_MHz) || "", { className: "nowrap" });
    appendCell(tr, getPolBandLabel(tp.pol, tp.frequency_MHz) || "", { className: "nowrap" });
    appendCell(tr, tp.symbolrate_kSps || "", { className: "nowrap" });
    appendCell(tr, tp.dvb || "", { className: "nowrap" });
    appendCell(tr, tp.tsid_onid || (tp.tsid ? `${tp.tsid}/${tp.onid || ""}` : ""), { className: "nowrap" });

    const progCell = appendCell(tr, "", { className: "nowrap" });
    appendStatusPill(
      progCell,
      progCount,
      "background:rgba(56,189,248,.14);border-color:rgba(56,189,248,.28)"
    );

    const actionsCell = appendCell(tr, "", { className: "nowrap" });
    const actions = document.createElement("div");
    actions.className = "actions";
    actionsCell.appendChild(actions);

    appendButton(actions, {
      label: selected ? "✓" : "＋",
      className: selected ? "primary" : "",
      dataset: { act: "toggle_sel", key },
    });
    appendButton(actions, {
      label: "Entf.",
      title: "Entfernen",
      dataset: { act: "unstarOwn", key },
    });

    tbody.appendChild(tr);

    if (isOpen) {
      tbody.appendChild(renderDetailsRow(key, 11));
    }
  }
}

export function updateFavBadges() {
  const set = (id, n) => {
    const e = document.getElementById(id);
    if (e) e.textContent = String(n);
  };

  set("favFtaTabCount", keysFromFavList(FREE_TO_AIR_DE).length);
  set("favSkyTabCount", keysFromFavList(SKY_DE).length);
  set("favHdTabCount", keysFromFavList(HDPLUS).length);
  set("favK20TabCount", keysFromFavList(TELEVES_K20_16).length);
  set("favOwnTabCount", ownFavKeys().length);

  const ownBtn = document.getElementById("favOwnTabBtn");
  if (ownBtn) ownBtn.style.display = ownFavKeys().length ? "" : "none";
}

export function renderFavoritesPanel() {
  renderFavList("ftaFavTbody", FREE_TO_AIR_DE);
  renderFavList("skyFavTbody", SKY_DE);
  renderFavList("hdFavTbody", HDPLUS);
  renderFavList("k20FavTbody", TELEVES_K20_16);
  renderOwnFav();
  updateFavBadges();

  bindSelectAll("selectAllFtaBtn", keysFromFavList(FREE_TO_AIR_DE));
  bindSelectAll("selectAllSkyBtn", keysFromFavList(SKY_DE));
  bindSelectAll("selectAllHdBtn", keysFromFavList(HDPLUS));
  bindSelectAll("selectAllK20Btn", keysFromFavList(TELEVES_K20_16));
  bindSelectAll("selectAllOwnBtn", ownFavKeys());
}
